export const MESSAGE_ERROR = 'error';
export const MESSAGE_INFO = 'info';
export const MESSAGE_WARNING = 'warning';
export const MESSAGE_TYPES = [MESSAGE_ERROR, MESSAGE_INFO, MESSAGE_WARNING] as const;
export type MESSAGE_TYPE = (typeof MESSAGE_TYPES)[number];
